<template>

    <div id="payments">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Payments</h1>
            </div>

            <div class="flex mb-4 justify-end"></div>
        </div>

        <div class="flex flex-col"  v-if="loaded">

            <div class="index-table" v-if="form.indexDataAvailable()">
                <div>
                    <div>
                        <table>
                            <thead>
                            <tr>
                                <th scope="col" class="text-left tracking-wider">&nbsp;</th>
                                <th scope="col" class="text-left tracking-wider">Payment Reference</th>
                                <th scope="col" class="hidden lg:table-cell p-3 text-left tracking-wider">Payment Method</th>
                                <th scope="col" class="hidden lg:table-cell p-3 text-left tracking-wider">Facility</th>
                                <th scope="col" class="p-3 text-left tracking-wider">Amount</th>
                                <th scope="col" class="p-3 text-center tracking-wider">Status</th>
                                <th scope="col" class="hidden lg:table-cell p-3 text-right">Payment / Approval Date</th>
                                <th scope="col" class="p-3 text-right"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="colored-row" v-for="(payment, index) in form.index_data.data" @click.prevent="">
                                <td>&nbsp;</td>
                                <td>
                                    <span class="font-medium">{{ payment.reference }}</span><br>
                                    <span class="uppercase">{{ payment.gateway_reference ? payment.gateway_reference : '-' }}</span>
                                </td>
                                <td class="hidden lg:table-cell">
                                    <span class="uppercase font-medium">{{ payment.gateway }}</span>
                                </td>
                                <td class="hidden lg:table-cell">
                                    <span class="font-medium">{{ payment.payment_account_name }}</span><br>
                                    <span class="uppercase">{{ payment.type }}</span>
                                </td>
                                <td>
                                    {{ formatCurrency(payment.payment_currency, payment.amount / 100) }}
                                </td>
                                <td class="text-center">
                                    <span class="status-box status-complete" v-if="payment.approved === true">Approved</span>
                                    <span class="status-box status-cancelled" v-else-if="payment.approved === false">Rejected</span>
                                    <span class="status-box status-pending" v-else>Pending</span>
                                </td>
                                <td class="hidden lg:table-cell text-right">
                                    {{ formatDate(payment.created_at) }}<br>
                                    <span v-if="payment.approved_at">{{ payment.approved_at }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td class="text-center">
                                    <div class="form-control col-span-6 xl:col-span-4" v-if="payment.approved === null">
                                        <select name="payment_approval" id="payment_approval" @change="actionPayment($event, index)">
                                            <option :value="null">Select Payment Action</option>
                                            <option value="1">Approve Payment</option>
                                            <option value="0">Reject Payment</option>
                                        </select>
                                    </div>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                            <tr class="py-6 text-xs font-medium">
                                <td colspan="8" class="text-center">
                                    <infinite-loading @infinite="infiniteHandler">
                                        <div slot="spinner">Loading...</div>
                                        <div slot="no-more">No more Payments</div>
                                    </infinite-loading>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div class="panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Payments Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any payments.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Payments" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Payment} from "../../app/Payment/Payment";
import InfiniteLoading from "vue-infinite-loading";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Payments",
    mixins: [PermissionMixin, FormattingMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading,
        InfiniteLoading
    },
    methods: {
        actionPayment(event, index) {
            let vm = this;

            vm.form.actionPayment(event, index).then(result => {
                vm.$forceUpdate();
            });
        },
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.index(true).then(response => {
                    $state.loaded();
                });
            } else {
                $state.loaded();
                $state.complete();
            }
        },
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Payment();

            vm.form.index().then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


